import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = ["input", "results", "selectedId", "display"];

  connect() {
    StimulusReflex.register(this);
    console.log("TeamMembershipOrganizationSearchController connected");
    console.log("Controller element:", this.element);
    console.log("Targets:", {
      input: this.hasInputTarget,
      results: this.hasResultsTarget,
      selectedId: this.hasSelectedIdTarget,
    });
  }

  search() {
    const query = this.inputTarget.value.trim();
    console.log("Search triggered with query:", query);

    if (query.length < 2) {
      console.log("Query too short, hiding results");
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Set the query in the dataset for the reflex to access
    this.element.dataset.query = query;
    console.log("Triggering reflex with query:", query);

    // Trigger the reflex
    this.stimulate("TeamMembershipOrganizationSearch#search");
  }

  // Reflex lifecycle methods
  beforeSearch() {
    console.log("Before search - adding loading state");
    this.resultsTarget.classList.add("opacity-50");
  }

  searchSuccess() {
    console.log("Search success - showing results");
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.remove("hidden");
  }

  searchError(error) {
    console.error("Search error:", error);
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
  }

  select(event) {
    const organizationId = event.currentTarget.dataset.organizationId;
    const organizationName = event.currentTarget.dataset.organizationName;

    // Set the hidden field value
    this.selectedIdTarget.value = organizationId;

    // Update the display
    this.inputTarget.value = organizationName;

    // Hide results
    this.resultsTarget.classList.add("hidden");

    // Trigger change event for form validation
    this.selectedIdTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }

  clear() {
    this.inputTarget.value = "";
    this.selectedIdTarget.value = "";
    this.resultsTarget.classList.add("hidden");
  }

  // Clear selection when user types to search for a different organization
  inputChanged() {
    if (this.selectedIdTarget.value) {
      this.selectedIdTarget.value = "";
    }
  }
}
